/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment, useState} from "react";
import * as PropTypes from "prop-types";
import {AddSpeciesModal} from "../Modals/AddSpeciesModal";
import {SpeciesRequestModal} from "../Modals/SpeciesRequestModal";
import {usePermission} from "../../../../../Hooks/PermissionHooks";


export const SpeciesEmptyMessageFooter = (props) => {

	const permission = usePermission();
	const canEditSpecies = permission?.('can_alter_global_species_list');

	const [editingSpecies, setEditingSpecies] = useState(null);

	const {
		addSpeciesButtonLabel = canEditSpecies ? "Add A Species" : "Request A New Species",
		addModalComponent: ModalComponent = (canEditSpecies ? AddSpeciesModal : SpeciesRequestModal),
		onReload = (species) => {},
	} = props;

	const openSpeciesEditor = (id) => {
		setEditingSpecies({
			speciesTypeId: 1,
			speciesNativityId: 1,
			speciesInvasivityId: 0,
			isDefault: true,
		});
	};

	return <Fragment>
		<br/>
		<div>
			If you don't see the species you are looking for you can
			{" "}
			<a type="button" className="link-primary"
			   onClick={() => void openSpeciesEditor()}
			>
				{addSpeciesButtonLabel?.toLocaleLowerCase()}
			</a>.
		</div>
		<ModalComponent
			show={!!editingSpecies}
			species={editingSpecies}
			onHide={() => void setEditingSpecies(null)}
			onReload={onReload}
			onUpdate={setEditingSpecies}
		/>
	</Fragment>;
}

SpeciesEmptyMessageFooter.propTypes = {
	onClick: PropTypes.func,
	addSpeciesButtonLabel: PropTypes.string
};
